export const getBrandName = (cardCode) => {
  const brandMap = {
    CB: 'CB',
    VISA: 'Visa',
    VISA_ELECTRON: 'Visa Electron',
    MASTERCARD: 'Mastercard',
    MAESTRO: 'Maestro',
    AMEX: 'American Express',
    DINERS: 'Diners',
    JCB: 'JCB',
    UNION_PAY: 'UnionPay',
  };
  return brandMap[cardCode] || cardCode || 'Carte';
};

export const formatCardNumber = (number) => {
  if (!number) return '';
  return number
    .replace(/\s/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim();
};

export const maskCardNumber = (number) => {
  if (!number || number.length < 4) return number;
  const last4 = number.slice(-4);
  return `**** **** **** ${last4}`;
};

export const getCardTypeFromNumber = (number) => {
  if (!number) return null;
  const cleaned = number.replace(/\s/g, '');

  if (/^4/.test(cleaned)) return 'VISA';
  if (/^5[1-5]/.test(cleaned)) return 'MASTERCARD';
  if (/^3[47]/.test(cleaned)) return 'AMEX';
  if (/^3[068]/.test(cleaned)) return 'DINERS';
  if (/^6(?:011|5)/.test(cleaned)) return 'DISCOVER';
  if (/^35/.test(cleaned)) return 'JCB';
  if (/^5[6-9]/.test(cleaned)) return 'MAESTRO';

  return null;
};
